export default "__VITE_ASSET__DoKZHMT4__"